/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createFalse } from '../../factoriesAny.js';
export var falseDependencies = {
  createFalse
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesFalse.generated.js
// module id = 1361
// module chunks = 2